/* IPERTECH 2026 — UI controller v2 (drawer + mega panel + sticky header + wishlist localStorage + correzione stima spedizione) */
(function(){
  'use strict';
  var WISHLIST_KEY = 'ipt_wishlist_v1';
  var $ = function(s, c){ return (c||document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  /* ============ DRAWER + MEGA PANEL ============ */
  function initDrawer(){
    var drawer = $('[data-ipt-drawer]');
    var overlay = $('[data-ipt-drawer-overlay]');
    var openBtns = $$('[data-ipt-drawer-open]');
    var closeBtn = $('[data-ipt-drawer-close]');
    var megas = $$('[data-ipt-mega]');

    if(!drawer || !overlay) return;

    function closeAllMegas(){
      megas.forEach(function(m){ m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); });
    }
    function openMega(id){
      closeAllMegas();
      var m = document.getElementById(id);
      if(m){ m.classList.add('is-open'); m.setAttribute('aria-hidden','false'); }
    }
    function openDrawer(){
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('ipt-drawer-open');
      drawer.setAttribute('aria-hidden','false');
      var first = drawer.querySelector('button, a');
      if(first) setTimeout(function(){ try{ first.focus(); }catch(e){} }, 100);
    }
    function closeDrawer(){
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.classList.remove('ipt-drawer-open');
      drawer.setAttribute('aria-hidden','true');
      closeAllMegas();
    }

    openBtns.forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); });
    });
    if(closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

    /* sub-menu accordion (mobile-style fallback) */
    $$('[data-ipt-drawer-toggle]', drawer).forEach(function(t){
      t.addEventListener('click', function(e){
        e.preventDefault();
        var target = document.getElementById(t.getAttribute('data-ipt-drawer-toggle'));
        if(target){
          target.classList.toggle('is-open');
          t.classList.toggle('is-open');
          t.setAttribute('aria-expanded', target.classList.contains('is-open') ? 'true' : 'false');
        }
      });
    });

    /* mega panel triggers */
    $$('[data-ipt-mega-open]', drawer).forEach(function(t){
      t.addEventListener('click', function(e){
        e.preventDefault();
        var id = t.getAttribute('data-ipt-mega-open');
        if(id) openMega(id);
      });
    });

    /* mega panel back / close */
    $$('[data-ipt-mega-back]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); closeAllMegas(); });
    });
    $$('[data-ipt-mega-close]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); closeDrawer(); });
    });
  }

  /* ============ STICKY HEADER ============ */
  function initSticky(){
    var wraps = $$('[data-ipt-sticky-header="true"]');
    if(!wraps.length) return;
    var threshold = 80;
    var ticking = false;
    function update(){
      wraps.forEach(function(wrap){
        if(window.scrollY > threshold){ wrap.classList.add('is-sticky'); }
        else { wrap.classList.remove('is-sticky'); }
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if(!ticking){ window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
  }

  /* ============ WISHLIST (localStorage) ============ */
  function getWishlist(){
    try { var raw = localStorage.getItem(WISHLIST_KEY); return raw ? JSON.parse(raw) : []; }
    catch(e){ return []; }
  }
  function setWishlist(list){
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      updateWishlistBadge();
      window.dispatchEvent(new CustomEvent('ipt:wishlist:change', { detail: { count: list.length } }));
    } catch(e){}
  }
  function inWishlist(id){ return getWishlist().indexOf(String(id)) !== -1; }
  function toggleWishlist(id){
    id = String(id);
    var list = getWishlist();
    var idx = list.indexOf(id);
    if(idx === -1) list.push(id);
    else list.splice(idx, 1);
    setWishlist(list);
    return list.indexOf(id) !== -1;
  }
  function updateWishlistBadge(){
    var count = getWishlist().length;
    $$('[data-ipt-wishlist-count]').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }
  function initWishlist(){
    $$('[data-ipt-fav]').forEach(function(btn){
      var id = btn.getAttribute('data-ipt-fav');
      if(!id) return;
      var active = inWishlist(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if(active) btn.innerHTML = '❤';
    });
    updateWishlistBadge();
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-ipt-fav]');
      if(!btn) return;
      e.preventDefault(); e.stopPropagation();
      var id = btn.getAttribute('data-ipt-fav');
      if(!id) return;
      var active = toggleWishlist(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.innerHTML = active ? '❤' : '♡';
    });
  }

  /* ==========================================================================
     CORREZIONE DELLA STIMA SPEDIZIONE
     --------------------------------------------------------------------------
     Il widget [data-ipt-ship] e la sua logica stanno in
     sections/ipertech-product-page.liquid + assets/ipertech-product-page.js.
     Quella logica calcola  costo = base + perKg * peso (+ supplemento estero)
     e non sa esprimere una soglia a PESO: con i valori a zero dichiarerebbe
     "Gratuita" a chiunque, anche in Francia o per un frigorifero da 30 kg.

     Tariffe reali (profilo "Profilo generale"):
       - Italia: gratis fino a 10 kg, poi 28 EUR (10-20), 50 (20-100), 90 (>100)
       - Francia / Estero: gratis solo fino a 1 kg, poi a pagamento
       - Internazionale europa / Resto del mondo: nessuna fascia gratuita

     Quindi:
     1) PRIMA che il tema calcoli, l'etichetta "gratis" diventa
        "Calcolata al checkout": il valore di partenza non e' mai una promessa
        falsa, nemmeno se la rete fallisce. Non rimuovere questo passaggio.
     2) POI, letto il peso reale in grammi da /products/<handle>.js, si scrive
        "Gratuita" solo dove lo e' davvero: Italia, fino a 10 kg.

     Il punto 2 viene riapplicato piu' volte (load + due ritardi + cambio
     variante) perche' lo script del tema gira in un momento non garantito e
     altrimenti riscriverebbe sopra.
     ========================================================================== */
  var SAFE_COST_LABEL = 'Calcolata al checkout';
  var FREE_LABEL = 'Gratuita';
  var IT_FREE_MAX_GRAMS = 10000;

  function shipVariantId(){
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if(m) return m[1];
    var input = document.querySelector('[data-ipt-pp-id-select], input[name="id"], select[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function initShipEstimate(){
    var box = $('[data-ipt-ship]');
    if(!box) return;

    /* (1) fallback prudente, prima del calcolo del tema */
    box.setAttribute('data-free-label', SAFE_COST_LABEL);

    var costEl = $('[data-ipt-ship-cost]', box);
    if(!costEl) return;
    var country = (box.getAttribute('data-country') || 'IT').toUpperCase();
    var product = null;

    function apply(){
      if(!product || !product.variants || !product.variants.length) return;
      var id = shipVariantId();
      var v = null;
      if(id){
        for(var i = 0; i < product.variants.length; i++){
          if(String(product.variants[i].id) === id){ v = product.variants[i]; break; }
        }
      }
      if(!v) v = product.variants[0];

      if(v.requires_shipping === false){
        costEl.textContent = '';
        costEl.classList.remove('is-free');
        return;
      }
      /* in /products/<handle>.js il campo "weight" e' sempre in grammi */
      var g = v.weight;
      var free = country === 'IT' && typeof g === 'number' && g > 0 && g <= IT_FREE_MAX_GRAMS;
      costEl.textContent = free ? FREE_LABEL : SAFE_COST_LABEL;
      costEl.classList.toggle('is-free', free);
    }

    var handle = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if(!handle) return;

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if(!p) return;
        product = p;
        apply();
        /* lo script del tema puo' girare dopo di noi: si riscrive sopra */
        window.addEventListener('load', apply);
        setTimeout(apply, 400);
        setTimeout(apply, 1500);
        window.addEventListener('popstate', apply);
        document.addEventListener('change', function(e){
          if(e.target && e.target.closest &&
             e.target.closest('[data-ipt-pp-id-select], variant-selects, variant-radios, [name="id"], .product-form__input')){
            setTimeout(apply, 80);
          }
        });
      })
      .catch(function(){ /* resta il fallback prudente */ });
  }

  /* ============ INIT ============ */
  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function(){
    try { initDrawer(); } catch(e){ console.warn('[ipt-ui] drawer:', e); }
    try { initSticky(); } catch(e){ console.warn('[ipt-ui] sticky:', e); }
    try { initWishlist(); } catch(e){ console.warn('[ipt-ui] wishlist:', e); }
    try { initShipEstimate(); } catch(e){ console.warn('[ipt-ui] ship estimate:', e); }
  });

  window.IpertechUI = {
    wishlist: { get: getWishlist, has: inWishlist, toggle: toggleWishlist, count: function(){ return getWishlist().length; } }
  };
})();
